(() => {
  'use strict';

  const MOBILE_QUERY = '(max-width: 749px)';

  function initStickyPurchaseBar(root = document) {
    if (!document.body.classList.contains('template-product')) return;
    if (document.querySelector('.dv-sticky-atc')) return;

    const mainButton = root.querySelector('.product-form__submit, button[name="add"]');
    const title = root.querySelector('h1.product__title, .product__title h1, h1');
    const firstPrice = root.querySelector('[id^="price-"] .price, .product__info-container .price');
    if (!mainButton || !title || !firstPrice) return;

    const bar = document.createElement('aside');
    bar.className = 'dv-sticky-atc';
    bar.dataset.visible = 'false';
    bar.setAttribute('aria-label', 'Flýtikaup');
    bar.innerHTML = `
      <div class="dv-sticky-atc__summary">
        <span class="dv-sticky-atc__title"></span>
        <span class="dv-sticky-atc__price"></span>
      </div>
      <button class="dv-sticky-atc__button" type="button"></button>
    `;
    document.body.appendChild(bar);

    const stickyTitle = bar.querySelector('.dv-sticky-atc__title');
    const stickyPrice = bar.querySelector('.dv-sticky-atc__price');
    const stickyButton = bar.querySelector('.dv-sticky-atc__button');

    const sync = () => {
      const priceNow = document.querySelector('[id^="price-"] .price, .product__info-container .price') || firstPrice;
      const visiblePrice = Array.from(priceNow.querySelectorAll('.price-item')).find(
        (item) => item.offsetWidth || item.offsetHeight
      );
      stickyTitle.textContent = title.textContent.trim();
      stickyPrice.textContent = (visiblePrice || priceNow).textContent.replace(/\s+/g, ' ').trim();
      stickyButton.textContent = mainButton.textContent.replace(/\s+/g, ' ').trim() || 'Setja í körfu';
      stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
    };

    stickyButton.addEventListener('click', () => {
      if (!stickyButton.disabled) mainButton.click();
    });

    const updateVisibility = () => {
      const rect = mainButton.getBoundingClientRect();
      // Visible whenever the real button is off-screen, above or below it. It used to
      // appear only after scrolling past the button, so the first screen of a mobile
      // product page (button at ~1,500 px on a 390x844 phone) had no way to buy.
      const offScreen = rect.bottom < 0 || rect.top > window.innerHeight;
      const next = String(window.matchMedia(MOBILE_QUERY).matches && offScreen);
      // Write only on a real change: every write wakes the overlay observers.
      if (bar.dataset.visible !== next) bar.dataset.visible = next;
    };

    new IntersectionObserver(updateVisibility, { threshold: 0.05 }).observe(mainButton);
    let scrollFrame = 0;
    window.addEventListener('scroll', () => {
      if (scrollFrame) return;
      scrollFrame = window.requestAnimationFrame(() => {
        scrollFrame = 0;
        updateVisibility();
      });
    }, { passive: true });

    new MutationObserver(sync).observe(mainButton, { attributes: true, childList: true, subtree: true });
    const priceWrapper = firstPrice.closest('[id^="price-"]') || firstPrice.parentElement || firstPrice;
    new MutationObserver(sync).observe(priceWrapper, { childList: true, subtree: true });
    window.matchMedia(MOBILE_QUERY).addEventListener('change', updateVisibility);
    sync();
    updateVisibility();
  }

  // Purchase choice under the price on food pages (snippets/dv-askrift-cta.liquid).
  // "Í áskrift" turns add-to-cart, and the sticky bar that mirrors it, into "Skrá
  // áskrift": a subscription never goes through the Shopify cart, so the
  // button opens the signup with this product prefilled instead.
  const ASKRIFT_LABEL = 'Skrá áskrift';

  function initBuyMode(root = document) {
    const choice = root.querySelector('[data-dv-buy-mode]');
    if (!choice || choice.dataset.ready === 'true') return;
    const form = document.getElementById(choice.dataset.form || '');
    const label = form && form.querySelector('[name="add"] > span');
    const url = choice.dataset.askriftUrl;
    if (!label || !url) return;
    choice.dataset.ready = 'true';
    const note = choice.querySelector('[data-dv-buy-mode-note]');
    const subscribing = () => Boolean(choice.querySelector('input[value="askrift"]:checked'));
    let retailLabel = label.textContent;

    const sync = () => {
      const on = subscribing();
      document.body.classList.toggle('dv-state-buy-askrift', on);
      if (note) note.hidden = !on;
      const wanted = on ? ASKRIFT_LABEL : retailLabel;
      if (label.textContent !== wanted) label.textContent = wanted;
    };

    // Dawn rewrites the label after a variant change: keep its retail text for the
    // way back, and keep the subscription label while "Í áskrift" is chosen.
    new MutationObserver(() => {
      if (label.textContent !== ASKRIFT_LABEL) retailLabel = label.textContent;
      if (subscribing() && label.textContent !== ASKRIFT_LABEL) label.textContent = ASKRIFT_LABEL;
    }).observe(label, { childList: true, characterData: true, subtree: true });

    choice.addEventListener('change', sync);
    // Capture phase on the document runs before product-form.js adds to the cart.
    document.addEventListener('submit', (event) => {
      if (event.target !== form || !subscribing()) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      window.location.assign(url);
    }, true);
    sync();
  }

  function init(root = document) {
    document.body.dataset.dvSafeCore = 'ready';
    initStickyPurchaseBar(root);
    initBuyMode(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
